type ErrorData<T> = T | undefined;

export function getStatusErrorMessaging(status: number) {
  switch (status) {
    case 404:
      return 'Not found';
    case 413:
      return 'Data submitted exceeded current size limit';
    default:
      return 'Unknown error';
  }
}

export default class ApiError<T = void> extends Error {
  constructor(message: string, code = 0, data?: T, correlationId?: string) {
    super(message);

    Object.setPrototypeOf(this, ApiError.prototype);

    this._code = code;
    this._data = data;
    this._correlationId = correlationId;
  }

  private _code: number;
  private _data: ErrorData<T>;
  private _correlationId?: string;

  public get code() {
    return this._code;
  }

  public get data() {
    return this._data;
  }

  public get correlationId() {
    return this._correlationId;
  }
}
